import { View } from '../../../Models/View';
import { ViewsActionType, IRequestViewsAction, IReceiveViewsAction } from './Views.action-types';

export function requestViews(applicationId: string): IRequestViewsAction {
  return {
    type: ViewsActionType.REQUEST_VIEWS,
    applicationId,
  };
}

export function receiveViews(views: View[]): IReceiveViewsAction {
  return {
    type: ViewsActionType.RECEIVE_VIEWS,
    views,
  };
}
